// The .js extension is required: the node:test runner resolves ESM strictly, unlike Vite.
import { isIndia } from '../../../utils/countries.js';

/**
 * Whether the bank step asks for an IFSC (Indian account) or a SWIFT code.
 *
 * The vendor's country of origin decides it, and nothing else. An Indian registered address used to
 * count too, which meant an international vendor with an office in India was asked for an IFSC their
 * bank does not have, with no way past the step.
 *
 * BankInformationStep uses this same test to pick which of the two inputs to show, so the code that
 * validation demands always has a field on screen. Keep the two in step.
 */
export const bankIsIndian = (formData = {}) => isIndia(formData.countryOrigin);
